module.exports = __webpack_public_path__ + "img/Yoseftal_Hospital.d892c534.svg";